import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { json, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Chip,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialButton from "../../../components/MaterialButton";
import BASEURL from "../../Utils/Baseurl";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { AllEmployeeDetailsQuery,AllCustomerDetailsQuery,allLeadprospect } from "../../../lib/graphQL/graphQuery";
import { Updatemutation,CreateMutation } from "../GraphQl";
import {useLoading} from '../../../context/LodingContext'
import {useSuccess} from '../../../context/SucccessContext'
import {useError} from '../../../context/ErrorContext'
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import PDFSelector from "../../../components/PdfSelector";
import { BsFillPersonBadgeFill } from "react-icons/bs";
function Addtaskcreation() {

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const { currentUser } = useAuth();
 
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } = useError();
  const [taskcreation, settaskcreation] = useState({
    dateassigned: new Date().toISOString().split("T")[0],
    tasktitle: "",
    taskmodule: "",
    assignedsaleperson: "",
    customername: "",
    leadname: "",
    description: "",
    startdate: "",
    enddate: "",
    deadlinedate: "",
    file: "",
    requestedOnStatus: "unchecked",
    tasktitleStatus: "unchecked",
    taskmoduleStatus: "unchecked",
    assignedsalepersonStatus: "unchecked",
    customernameStatus: "unchecked",
    leadnameStatus: "unchecked",
    dateassignedStatus: "unchecked",
    descriptionStatus: "unchecked",
    startdateStatus: "unchecked",
    enddateStatus: "unchecked",
    deadlinedateStatus: "unchecked",
  });
  
  const [selectedPriority, setSelectedPriority] = useState('Medium');
  const priorities = ['Low', 'Medium', 'High'];
  const navigate = useNavigate()
  const [AllCustomers,setAllCustomers] = useState([])
  const [Allleadname,setAllleadname] = useState([])
  const [Allemp,setAllemp] = useState([])
  const [Id,setId] = useState('')

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id)
    if (id) {
      getInitData(id);
    }
  }, []);

  useEffect(()=>{
    GetEmpNames();
    GetCustomerName();
    GetLeadName();
  },[])


  const GetEmpNames = async () => {
    const query = `
      query getUserDetailByMaster($id: String!) {
        getUserDetailByMaster(id: $id) {
          id
          username
          email
          role
          contactno
          lastUpdate
        }
      }
    `;
  
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            id: currentUser?.id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
    let result = response.data.data?.getUserDetailByMaster
    setAllemp(result)
    } catch (error) {
      console.error("Response Error:", error);
    }
  };
  
  const GetCustomerName = async()=>{
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: AllCustomerDetailsQuery,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let result = response.data.data.allCustomer
    
      setAllCustomers(result)
    } catch (error) {
      console.error('Response Error:',error);
      
    }
  }

  const GetLeadName = async()=>{
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: allLeadprospect,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      
      let result = response.data.data?.allLeadprospect
    
      setAllleadname(result)
    } catch (error) {
      console.error('Response Error:',error);
      
    }
  }

  const handletaskcreationchange = (event, selectEvent) => {
    let taskcreationState = { ...taskcreation };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "assignedsaleperson") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          taskcreationState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          taskcreationState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "customername") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          taskcreationState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          taskcreationState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "leadname") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          taskcreationState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          taskcreationState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      taskcreationState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "tasktitle":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,50})$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              taskcreationState[event.target.name + "Status"] = "success";
            } else {
              taskcreationState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "taskmodule":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,50})$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              taskcreationState[event.target.name + "Status"] = "success";
            } else {
              taskcreationState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "startdate":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (dateLengthRegex.test(event.target.value?.trim())) {
              taskcreationState[event.target.name + "Status"] = "success";
            } else {
              taskcreationState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "enddate":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );

            if (dateLengthRegex.test(event.target.value?.trim())) {
              taskcreationState[event.target.name + "Status"] = "success";
            } else {
              taskcreationState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

          case "deadlinedate":
            {
              const dateLengthRegex = new RegExp(
                "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
              );
  
              if (dateLengthRegex.test(event.target.value?.trim())) {
                taskcreationState[event.target.name + "Status"] = "success";
              } else {
                taskcreationState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;

        case "description":
          {
            const descriptionRegex = new RegExp("^([\\s\\S]{10,250})$");

            if (descriptionRegex.test(event.target.value?.trim())) {
              taskcreationState[event.target.name + "Status"] = "success";
            } else {
              taskcreationState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        taskcreationState[event.target.name] = event.target.value;
      }
    }
    settaskcreation(taskcreationState);
  };

  const handleAddtaskcreation = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  
  const handleCanceltaskcreation = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Cancel your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handlecancel();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
   const handlecancel = ()=>{
    navigate('/taskcreation')
   }

   //Fetch Data By ID
  const getInitData = async(id)=>{
    const query = `
    query GetTaskById($id: Int!) { 
  taskById(id: $id) { 
    success 
    message 
    data { 
      id 
      title 
      module 
      description 
      priority 
      status 
      requestedDate 
      startDate 
      endDate 
      deadlineDate 
      customer { 
      id
        legalName 
      } 
      lead { 
       id
        firstName 
      } 
      assignedTo { 
      id
        username 
      }
      attachment 
    } 
  } 
} `

try {
  const response = await axios.post(
    BASEURL,
    {
      query: query,
      variables: { id },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
let result = response.data?.data?.taskById?.data
const cleanBaseUrl = BASEURL.slice(0,-8);

settaskcreation({
  ...taskcreation,
  tasktitle: result[0]?.title,
  taskmodule : result[0]?.module,
  assignedsaleperson : {value : result[0]?.assignedTo.id,label:result[0]?.assignedTo.username},
  customername : {value : result[0]?.customer.id,label:result[0]?.customer.legalName},
  leadname : {value : result[0]?.lead?.id,label : result[0]?.lead?.firstName },
  dateassigned: result[0]?.requestedDate?.split("T")[0],
  startdate: result[0]?.startDate?.split("T")[0],
  enddate: result[0]?.endDate?.split("T")[0],
  deadlinedate: result[0]?.deadlineDate
  ? new Date(result[0].deadlineDate).toISOString().slice(0, 16)
  : '',
  description : result[0]?.description,
  file: result[0]?.attachment 
  ? `${cleanBaseUrl}media/${result[0].attachment}` 
  : '',


  tasktitleStatus: result[0]?.title ? "success" : "unchecked",
  taskmoduleStatus : result[0]?.module ? "success" : "unchecked",
  assignedsalepersonStatus : {value : result[0]?.assignedTo.id,label:result[0]?.assignedTo.username} ? "success" : "unchecked",
  customernameStatus : {value : result[0]?.customer.id,label:result[0]?.customer.legalName} ? "success" : "unchecked",
  leadnameStatus : {value : result[0]?.lead?.id,label : result[0]?.lead?.firstName } ? "success" : "unchecked",
  dateassignedStatus: result[0]?.requestedDate?.split("T")[0] ? "success" : "unchecked",
  startdateStatus: result[0]?.startDate?.split("T")[0] ? "success" : "unchecked",
  enddateStatus: result[0]?.endDate?.split("T")[0] ? "success" : "unchecked",
  deadlinedateStatus: result[0]?.deadlineDate
  ? new Date(result[0].deadlineDate).toISOString().slice(0, 16)
  : '' ? "success" : "unchecked",
  descriptionStatus : result[0]?.description ? "success" : "unchecked",
})
setSelectedPriority(result[0]?.priority)
} catch (error) {
  
}
    setTogglePage({
        ...togglePage,
        view: true,
      });
  }

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  
  };

    //Create Mutation
    const handleSubmit = async()=>{
      const input= {
        title: taskcreation.tasktitle,
        module: taskcreation.taskmodule,
        description: taskcreation.description,
        assignedTo: taskcreation.assignedsaleperson?.value,
        customer: taskcreation.customername?.value,
        lead: taskcreation.leadname?.value,
        requestedDate: new Date(taskcreation.dateassigned).toISOString(),
        startDate: new Date(taskcreation.startdate).toISOString(),
        endDate: new Date(taskcreation.enddate).toISOString(),
        deadlineDate: taskcreation.deadlinedate,
        status: 'Inprogress',
        priority: selectedPriority,
        attachment: null,
      }

      const operations = JSON.stringify({
        query: CreateMutation,
        variables: { input },
      });
      const map = JSON.stringify({
        "0": ["variables.input.attachment"],
      });
    
      const formData = new FormData();
      formData.append("operations", operations);
      formData.append("map", map);
      formData.append("0", taskcreation.file);
    
    
      try {
        const { data } = await axios.post(BASEURL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
    
        const result = data.data?.createTask;
    
        if (result?.success) {
          setSuccessStatus(true);
          setSucessTitle("Task Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/taskcreation");
          }, 1000);
        }
      } catch (error) {
        console.error(error);
        setErrorStatus(true);
            setErrormessage(error.message);
   
            setTimeout(() => {
              setErrorStatus(false);
            }, 3000);
      }
  }

  //Update Mutation
  const handleUpdate = async () => {
    const formatToDateTime = (date) => new Date(date).toISOString();
    const isFile = taskcreation.file instanceof File;
    const input = {
      id: Id,
      title: taskcreation.tasktitle,
      module: taskcreation.taskmodule,
      description: taskcreation.description,
      assignedTo: taskcreation.assignedsaleperson?.value,
      customer: taskcreation.customername?.value,
      lead: taskcreation.leadname?.value,
      requestedDate: formatToDateTime(taskcreation.dateassigned),
      startDate: formatToDateTime(taskcreation.startdate),
      endDate: formatToDateTime(taskcreation.enddate),
      deadlineDate: taskcreation.deadlinedate,
      status: 'Inprogress',
      priority: selectedPriority,
      attachment: isFile ? null : taskcreation.file, 
    };
  
    const operations = JSON.stringify({
      query: Updatemutation,
      variables: { input },
    });
  
    const map = JSON.stringify({
      "0": ["variables.input.attachment"],
    });
  
    const formData = new FormData();
    formData.append("operations", operations);
    formData.append("map", map);
    
    // Append file only if it exists
    if (taskcreation.file) {
      formData.append("0", taskcreation.file);
    }
  
    try {
      if (isFile) {
        // multipart upload
        const operations = JSON.stringify({
          query: Updatemutation,
          variables: { input },
        });
        const map = JSON.stringify({
          "0": ["variables.input.attachment"],
        });
        const formData = new FormData();
        formData.append("operations", operations);
        formData.append("map", map);
        formData.append("0", taskcreation.file);
  
        const { data } = await axios.post(BASEURL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
  
        const result = data.data?.updateTask;
        if (result?.success) {
          setSuccessStatus(true);
          setSucessTitle("Task Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/taskcreation");
          }, 1000);
        }
      } else {
        // regular JSON request with file path
        const { data } = await axios.post(
          BASEURL,
          {
            query: Updatemutation,
            variables: { input },
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
  
        const result = data.data?.updateTask;
        if (result?.success) {
          setSuccessStatus(true);
          setSucessTitle("Task Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/taskcreation");
          }, 1000);
        }
      }
    } catch (error) {
      console.error(error);
      setErrorStatus(true);
      setErrormessage(error.message);
  
      setTimeout(() => {
        setErrorStatus(false);
      }, 3000);
    }
  }; 
  

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteDesignationSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

//Delete Mutation
  const onDeleteDesignationSubmit = async () => {
    const query = `
           mutation DeleteTask($id: ID!) { 

  deleteTask(id: $id) { 

    success 

    error 

    message 

  } 

} 
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: Id,
        },
      });

      let result = response.data.data?.deleteTask

      if(result.success){
        setSuccessStatus(true);
          setSucessTitle("Task Deleted ");
          setTimeout(()=> {
            setSuccessStatus(false);
            navigate("/taskcreation")
          },1000);
 
      }
    
    } catch (error) {
      console.error("An error occurred while deleting the designation:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] ?? null;
  
    if (file) {

      if (file.size > 20 * 1024 * 1024) {
        setErrorStatus(true);
          setErrormessage("File too large! Maximum size is 20MB");
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
      }
      const reader = new FileReader();
  
      reader.onload = () => {
        settaskcreation((prev) => ({
          ...prev,
          file: file,
          filePreviewUrl: reader.result,  // Add preview URL here
        }));
      };
  
      reader.readAsDataURL(file);
    } else {
      // If no file selected (e.g. user cancels)
      settaskcreation((prev) => ({
        ...prev,
        file: null,
        filePreviewUrl: null,
      }));
    }
  };
  

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.edit || togglePage.view ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      {togglePage.view
                        ? "View Task Creation"
                        : "Edit Task Creation"}
                    </MaterialTypography>
                  </Stack>

                  <ButtonGroup
                    variant="outlined"
                    aria-label="Action button group"
                    size="small"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>

                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={AddDelete}
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  padding={1}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Task Creation
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />

        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                           <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                           <MaterialTypography
                                           sx={{color:'#460058',fontFamily:'Aptos'}}
                                             component="label"
                                             variant="body2"
                                             fontWeight="700"
                                           >
                                             Task Information
                                           </MaterialTypography>
                                         </Stack>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Task Title
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="tasktitle"
                  type="text"
                  value={taskcreation.tasktitle}
                  onChange={handletaskcreationchange}
                  error={taskcreation.tasktitleStatus === "error"}
                  success={taskcreation.tasktitleStatus === "success"}
                  disabled={togglePage.view === true ? true : false}
                />
                {taskcreation.tasktitleStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Task Title should be maximum 50 characters long and can
                      contain only alphabets
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Task Module
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="taskmodule"
                  type="text"
                  value={taskcreation.taskmodule}
                  onChange={handletaskcreationchange}
                  error={taskcreation.taskmoduleStatus === "error"}
                  success={taskcreation.taskmoduleStatus === "success"}
                  disabled={togglePage.view === true ? true : false}
                />
                {taskcreation.taskmoduleStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Module should be maximum 50 characters long and can
                      contain only alphabets
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Assign Salesperson
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="assignedsaleperson"
                  options={Allemp.map((val) => {
                    return {
                      value: val.id,
                      label: val.username,
                    };
                  })}
                  value={taskcreation.assignedsaleperson}
                  onChange={handletaskcreationchange}
                  error={taskcreation.assignedsalepersonStatus === "error"}
                  success={taskcreation.assignedsalepersonStatus === "success"}
                  isDisabled={togglePage.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Add Customer Name
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="customername"
                  options={AllCustomers?.map((val) => {
                    return {
                      value: val.id,
                      label: val.legalName,
                    };
                  })}
                  value={taskcreation.customername}
                  onChange={handletaskcreationchange}
                  error={taskcreation.customernameStatus === "error"}
                  success={taskcreation.customernameStatus === "success"}
                  isDisabled={togglePage.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Add Lead Name
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="leadname"
                  options={Allleadname?.map((val) => {
                    return {
                      value: val.id,
                      label: val.companyName,
                    };
                  })}
                  value={taskcreation.leadname}
                  onChange={handletaskcreationchange}
                  error={taskcreation.leadnameStatus === "error"}
                  success={taskcreation.leadnameStatus === "success"}
                  isDisabled={togglePage.view === true ? true : false}
                />
              </Grid>

              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Date Assigned
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="dateassigned"
                  type="date"
                  // inputProps={{
                  //   min: new Date().toISOString().split("T")[0],
                  // }}
                  value={taskcreation.dateassigned}
                  //   onChange={handletaskcreationchange}
                  error={
                    taskcreation.dateassignedStatus === "error" ? true : false
                  }
                  success={
                    taskcreation.dateassignedStatus === "success" ? true : false
                  }
                  readOnly
                  disabled={togglePage.view === true ? true : false}
                />
              </Grid>

              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Start Date
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="startdate"
                  type="date"
                  // inputProps={{
                  //   min: new Date().toISOString().split("T")[0],
                  // }}
                  value={taskcreation.startdate}
                  onChange={handletaskcreationchange}
                  error={
                    taskcreation.startdateStatus === "error" ? true : false
                  }
                  success={
                    taskcreation.startdateStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  inputProps={{
                    min: taskcreation.dateassigned || ""
                  }}
                />
              </Grid>

              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    End Date
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="enddate"
                  type="date"
                  // min={taskcreation.leaveFrom}
                  //   inputProps={{
                  //     min: taskcreation.leaveFrom,
                  //   }}

                  value={taskcreation.enddate}
                  onChange={handletaskcreationchange}
                  error={taskcreation.enddateStatus === "error" ? true : false}
                  success={
                    taskcreation.enddateStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  inputProps={{
                    min: taskcreation.startdate || ""
                  }}
                />
              </Grid>
              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Deadline Date
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="deadlinedate"
                  type="datetime-local"
                  // min={taskcreation.leaveFrom}
                  //   inputProps={{
                  //     min: taskcreation.leaveFrom,
                  //   }}

                  value={taskcreation.deadlinedate}
                  onChange={handletaskcreationchange}
                  error={taskcreation.deadlinedateStatus === "error" ? true : false}
                  success={
                    taskcreation.deadlinedateStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                  inputProps={{
                    min: taskcreation.dateassigned
                    ? new Date(taskcreation.dateassigned).toISOString().slice(0, 16)
                    : "",
                  }}
                />
              </Grid>
              <Grid size={{ xs: 4, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Description
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="description"
                  // placeholder="eg. Reason"
                  multiline
                  rows={5}
                  value={taskcreation.description}
                  onChange={handletaskcreationchange}
                  error={taskcreation.descriptionStatus === "error"}
                  success={taskcreation.descriptionStatus === "success"}
                  disabled={togglePage.view === true ? true : false}
                />
                {taskcreation.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Description should be a minimum 10 characters & maximum
                      250 characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

     
            

              <Grid item xs={12} sm={4}>
     
      <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Priority Selection
                  </MaterialTypography>
                </MaterialBox>
        <Stack direction="row" spacing={1.5}>
          {priorities.map((priority) => (
            <Chip
              key={priority}
              label={priority}
              clickable
              color={selectedPriority === priority ? 'primary' : 'default'}
              variant={selectedPriority === priority ? 'filled' : 'outlined'}
              onClick={() => setSelectedPriority(priority)}
              disabled={togglePage.view === true ? true : false}
            />
          ))}
        </Stack>
     
    </Grid>
     
            </Grid>
        

          </MaterialBox>
          <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} sm={6}>
  <MaterialBox lineHeight={0} display="inline-block">
    <MaterialTypography
      component="label"
      variant="caption"
      fontWeight="bold"
      htmlFor="pdf-input"
      sx={{ cursor: togglePage.view ? "default" : "pointer" }}
    >
      File Upload
    </MaterialTypography>
  </MaterialBox>

  {!togglePage.view && (
    <MaterialInput
      id="pdf-input"
      type="file"
      accept="application/pdf"
      onChange={handleFileChange}
      error={taskcreation.fileStatus === "error"}
      success={taskcreation.fileStatus === "success"}
      disabled={togglePage.view}
    />
  )}

  {taskcreation.fileStatus === "error" && (
    <FormControl error>
      <FormHelperText>
        Please upload a valid PDF file up to 20MB.
      </FormHelperText>
    </FormControl>
  )}

  {togglePage.view && taskcreation.file && (
    <MaterialBox mt={2}>
      <MaterialTypography variant="body2">
      <a 
        href={taskcreation.file} 
        target="_blank" 
        rel="noopener noreferrer" 
        style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}
      >
        <MaterialButton>
          View
        </MaterialButton>
      </a>

      </MaterialTypography>

    </MaterialBox>
  )}
</Grid>

{/* 
              {taskcreation.file && (
                <Grid item xs={12} sm={6}>
                  <MaterialBox mt={4}>
                    <iframe
                      title="PDF Preview"
                      src={URL.createObjectURL(taskcreation.file)}
                      width="500px"
                      height="280px"
                      style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                    />
                  </MaterialBox>
                </Grid>
              )} */}
            </Grid>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {togglePage.edit && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={handleCanceltaskcreation}
              >
                Cancel
              </MaterialButton>

              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkFields()}
                onClick={handleUpdate}
              >
                Update
              </MaterialButton>
            </>
          )}

{!togglePage.view && !togglePage.edit && (
            <>
          

           
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleCanceltaskcreation}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 4, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                //   disabled={!checkAllFields()}
                  onClick={handleAddtaskcreation}
              >
                Submit
              </MaterialButton>
            </>
         )}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
}

export default Addtaskcreation;
